import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuRoundAvatarComponent } from './au-round-avatar/au-round-avatar.component';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { AuUserInitialsPipe } from '@app/shared/pipes/au-user-initials.pipe';

@NgModule({
	imports: [
		CommonModule,
		AuUserInitialsPipe,
		MatIconModule,
		MatTooltipModule,
		AuRoundAvatarComponent,
	],
	exports: [AuRoundAvatarComponent],
})
export class AuRoundAvatarModule {}
